// extracted by mini-css-extract-plugin
module.exports = {"box":"legitimation_box__cuII-","wrapper":"legitimation_wrapper__2f8tA","checkbox":"legitimation_checkbox__3Y6Ws"};